import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { NetFacadeService } from 'netview';
import { SchedDiscPrtgExport } from 'DiscoveryEngine.TS/PRTG';
import { PrtgExportConfigComponent } from 'discovery';
import { ComponentBase, Changeable } from "common";
import { NetViewTreeNodeDto, NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';

@Component({
	selector: 'nvtn-prtg-export-config',
	templateUrl: '../nvtn-prtg-export-config/nvtn-prtg-export-config.component.html',
	styleUrls: ['../nvtn-prtg-export-config/nvtn-prtg-export-config.component.scss']
})
export class NvtnPrtgExportConfigComponent extends ComponentBase implements Changeable {

	@Input()
	public target: NetViewTreeNodeDto;
	public get hasTarget(): boolean {
		return !!this.target;
	}

	public network: NetViewDto;

    @ViewChild(PrtgExportConfigComponent, { static: true })
	private PrtgExportComp: PrtgExportConfigComponent;

	private static NullPrtgExport = new SchedDiscPrtgExport();

	public get prtgExport(): SchedDiscPrtgExport {
		if (this.target && this.target.HasRollupPrtgExport)
			return this.target.RollupPrtgExport;
		else
			return NvtnPrtgExportConfigComponent.NullPrtgExport;
	}

	constructor(private netFacadeService: NetFacadeService) {

		super();

		this.target = null;
		this.network = null;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.updateNetwork();
	}

	private updateNetwork(): void {
		this.network = null;
		if (this.target) {
			this.network = this.netFacadeService.findNetwork(this.target.ScopeGuid);
		}
	}

	public get tempChanges(): boolean {
		return this.PrtgExportComp.tempChanges;
	}

	public get tempChangesValid(): boolean {
		return this.PrtgExportComp.tempChangesValid;
	}

	public applyTempChanges(): void {
		this.PrtgExportComp.applyTempChanges();
		this.target.HasChanges = true;
	}

	public get invalidTempChanges(): string[] {
		return this.PrtgExportComp.invalidTempChanges;
	}

	public discardTempChanges(): void {
		this.PrtgExportComp.discardTempChanges();
	}

}
